import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import LessonInfo from './components/LessonInfo';
import OtherActions from './components/OtherActions';
import LessonTeachers from './components/LessonTeachers';
import LessonModules from './components/LessonModules';
import LessonMasteries from './components/LessonMasteries';

const useStyles = makeStyles(theme => ({
  root: {},
  card: {
    marginBottom: theme.spacing(3),
  }
}));

const Summary = props => {
  const { className, handleDelete, reload, ...rest } = props;
  const model = useSelector(state => state.models.lesson);

  const classes = useStyles();

  if (!model) {
    return null;
  }

  return (
    <Grid {...rest} className={clsx(classes.root, className)} container spacing={3}>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        <LessonInfo className={classes.card} />
        <OtherActions handleDelete={handleDelete} className={classes.card} />
      </Grid>
      <Grid item lg={8} md={12} xl={6} xs={12}>
        <LessonTeachers reload={reload} className={classes.card} />
        <LessonMasteries reload={reload} className={classes.card} />
        <LessonModules reload={reload} className={classes.card} />
      </Grid>
    </Grid>
  );
};

Summary.propTypes = {
  className: PropTypes.string
};

export default Summary;
